<script lang="ts">
	import { page } from '$app/stores';
	import MeekoTextLogo from '$lib/components/icons/meeko-text-logo.svelte';
	import { Container } from '$lib/components/ui/container';
	import { MenuIcon, XIcon } from 'lucide-svelte';
	import { fade } from 'svelte/transition';

	let scrollPos: number = 0;
	let hasScrolled: boolean = false;
	let mobileNavOpen: boolean = false;

	$: if (scrollPos > 60) {
		hasScrolled = true;
	} else {
		hasScrolled = false;
	}
</script>

<svelte:window bind:scrollY={scrollPos} />

<div
	class="flex items-center justify-center gap-x-6 bg-secondary px-6 py-2.5 sm:px-3.5 sm:before:flex-1"
>
	<p class="w-full text-center text-sm leading-6 text-lightPrimary">
		<strong class="font-semibold">Development Paused</strong><svg
			viewBox="0 0 2 2"
			class="mx-2 inline h-0.5 w-0.5 fill-current"
			aria-hidden="true"><circle cx="1" cy="1" r="1" /></svg
		>Meeko will be paused. All active subscriptions will be refunded. Thank you for your support and
		patience, more info coming soon.
	</p>
</div>
<Container
	class="z-50 mx-auto flex w-full flex-row flex-wrap items-center justify-between pt-6 lg:pt-8"
>
	<a href={$page.data?.user ? '/profile' : '/'} class="flex items-center gap-2 no-underline">
		<MeekoTextLogo class="mb-2 ml-2 h-5 w-auto lg:h-5" />
	</a>
</Container>
{#if hasScrolled}
	<div
		transition:fade={{ duration: 100 }}
		class="fixed inset-x-0 top-0 z-50 mx-auto flex w-full max-w-max flex-row flex-wrap items-center justify-between px-4 pt-3 lg:pt-8"
	>
		<div
			class="mx-auto flex w-[800px] items-center justify-between gap-4 rounded-full border border-darkTertiary bg-darkPrimary py-2 pl-4 pr-1"
		>
			<div class="flex items-center gap-2 py-1.5 no-underline">
				<enhanced:img
					src="/static/images/meeko/meeko-text-logo.png"
					alt="meeko.ai"
					class="ml-2 mt-0 h-4 w-auto lg:h-4"
				/>
			</div>
		</div>
	</div>
{/if}
